
import { useState } from 'react';
import { useI18n } from '../context/I18nContext';
import { API_BASE } from '../config';

export default function ContactModal({ onClose }) {
  const { t } = useI18n();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), subject: subject.trim(), message: message.trim() })
      });
      const data = await res.json();
      if (data.success) {
        setSent(true);
      } else {
        setError(data.error || 'Failed to send.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay show" role="dialog" aria-modal="true" aria-labelledby="contact-title">
      <div className="modal contact-modal">
        <div className="modal-header">
          <h2 id="contact-title">{t('contactUs') || 'Contactez-nous'}</h2>
          <button className="modal-close" onClick={onClose} aria-label={t('close')}>×</button>
        </div>
        <div className="modal-body">
          {sent ? (
            <div className="contact-success">
              <p>✅ {t('messageSent') || 'Message envoyé avec succès !'}</p>
              <p style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                {t('weWillReply') || 'Nous vous répondrons dans les plus brefs délais.'}
              </p>
              <button className="btn-primary" onClick={onClose} style={{ marginTop: '16px', width: '100%' }}>
                {t('close') || 'Fermer'}
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="field-group">
                <input
                  type="text"
                  placeholder={t('yourName') || 'Votre nom'}
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="field-group">
                <input
                  type="email"
                  placeholder={t('yourEmail') || 'Votre email'}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="field-group">
                <input
                  type="text"
                  placeholder={t('subject') || 'Sujet'}
                  value={subject}
                  onChange={e => setSubject(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className="field-group">
                <textarea
                  placeholder={t('yourMessage') || 'Votre message'}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  required
                  disabled={loading}
                  rows={5}
                  style={{ resize: 'vertical', width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-primary)', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </div>
              {error && <p style={{ color: 'var(--error)', fontSize: '13px', marginBottom: '10px' }}>{error}</p>}
              <button
                type="submit"
                className="btn-primary"
                disabled={loading || !name.trim() || !email.trim() || !message.trim()}
                style={{ width: '100%' }}
              >
                {loading ? '...' : (t('send') || 'Envoyer')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
